import { Link } from "react-router-dom";
import { Calculator, ClipboardCheck, FileSpreadsheet, Gauge, ArrowRight } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";

const TOOLS = [
  { icon: Gauge, title: "Intelligent SCM Scan", desc: "AI-powered maturity assessment across all four planning functions.", to: "/scan", cta: "Take the assessment" },
  { icon: Calculator, title: "Safety Stock Calculator", desc: "Calculate optimal safety stock from service level, lead time, and demand variability.", to: "/tools", cta: "Coming soon" },
  { icon: ClipboardCheck, title: "S&OP Maturity Scorecard", desc: "Score your S&OP process against best-practice governance criteria.", to: "/tools", cta: "Coming soon" },
  { icon: FileSpreadsheet, title: "Forecast Accuracy Tracker", desc: "A clean template to track MAPE, bias, and FVA by SKU and planner.", to: "/tools", cta: "Coming soon" },
];

export default function Tools() {
  return (
    <Layout>
      <Seo
        title="Supply Chain Planning Tools & Calculators | SCMBrain"
        description="Practical supply chain calculators, scorecards, and templates for planning teams — including the free Intelligent SCM Scan."
        path="/tools"
      />
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <p className="text-sm uppercase tracking-[0.2em] text-[#1A6B5A] font-semibold mb-4">SCM Tools</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-[#1B3A6B] max-w-2xl leading-tight">
          Practical calculators, scorecards, and templates.
        </h1>
        <p className="mt-5 text-lg text-[#3E577A] max-w-2xl">Built for supply chain teams. Free to use.</p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {TOOLS.map((t, i) => (
            <div key={i} data-testid={`tool-${i}`} className="bg-[#F4F4F4] border border-[#E5E7EB] border-l-4 border-l-[#1A6B5A] rounded-sm p-8 flex flex-col">
              <t.icon className="h-8 w-8 text-[#1A6B5A] mb-5" strokeWidth={1.8} />
              <h3 className="font-heading text-xl font-bold text-[#1B3A6B] mb-2">{t.title}</h3>
              <p className="text-[#3E577A] text-sm leading-relaxed mb-6 flex-1">{t.desc}</p>
              <Link to={t.to} className="text-[#1A6B5A] font-semibold text-sm inline-flex items-center gap-1 hover:gap-2 transition-all">{t.cta} <ArrowRight className="h-4 w-4" /></Link>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
